export default __webpack_public_path__ + "static/media/bannerAltaCentroTrabajo.3e75b7bb.jpeg";